import { createBundle } from 'widget/Common';

// ---- 产品浏览 模块 ----
import ProductCategoriesView from 'bundle-loader?lazy&name=ProductCategoriesView!pages/Shop/Product/ProductCategories/ProductCategoriesView';
import ProductSearchView from 'bundle-loader?lazy&name=ProductSearchView!pages/Shop/Product/ProductSearch/ProductSearchView';
import ProductClassifySearchView from 'bundle-loader?lazy&name=ProductClassifySearchView!pages/Shop/Product/ProductClassifySearch/indexView';
import ProductClassifySearchResultView from 'bundle-loader?lazy&name=ProductClassifySearchResultView!pages/Shop/Product/ProductClassifySearchResult/indexView';
import ProductListView from 'bundle-loader?lazy&name=ProductListView!pages/Shop/Product/ProductList/ProductListView';
import QualificationView from 'bundle-loader?lazy&name=QualificationView!pages/Shop/Product/Qualification/QualificationView';
import QualificationPageView from 'bundle-loader?lazy&name=QualificationPageView!pages/Shop/Product/QualificationPage/QualificationPageView';
import QualificationActivityListView from 'bundle-loader?lazy&name=QualificationActivityListView!pages/Shop/Product/QualificationActivityList/QualificationActivityListView';
import ProductDetailView from 'bundle-loader?lazy&name=ProductDetailView!pages/Shop/Product/ProductDetail/ProductDetailView';
import QuestionDetailView from 'bundle-loader?lazy&name=QuestionDetailView!pages/Shop/Product/ProductDetail/QuestionDetail/QuestionDetailView';
import ProductEvaluate from 'bundle-loader?lazy&name=ProductEvaluate!pages/Shop/Product/ProductDetail/ProductEvaluate/ProductEvaluateView';
import ProductEvaluateDetailView from 'bundle-loader?lazy&name=ProductEvaluateDetail!pages/Shop/Product/ProductDetail/ProductEvaluateDetail/ProductEvaluateDetailView';
import SpecialProductDetailView from 'bundle-loader?lazy&name=SpecialProductDetailView!pages/Shop/Product/SpecialProductDetail/ProductDetailView';
// ---- 下单支付 模块 ----
import ShoppingCartView from 'bundle-loader?lazy&name=ShoppingCartView!pages/Shop/ShoppingCart/ShoppingCartView';
import ActivityProductListView from 'bundle-loader?lazy&name=ActivityProductListView!pages/Shop/ShoppingCart/ActivityProductList/ActivityProductListView';
import CheckOrderView from 'bundle-loader?lazy&name=CheckOrderView!pages/Shop/CheckOrder/CheckOrderView';
import GiftCheckOrderView from 'bundle-loader?lazy&name=GiftCheckOrderView!pages/Shop/GiftCheckOrder/CheckOrderView';
import GiftNewAddressView from 'bundle-loader?lazy&name=GiftNewAddressView!pages/Shop/GiftCheckOrder/NewAddress/NewAddressView';
import GiftOrderDetailView from 'bundle-loader?lazy&name=GiftOrderDetailView!pages/Shop/GiftCheckOrder/Detail/DetailView';
import ShareProductsView from 'bundle-loader?lazy&name=ShareProductsView!pages/Shop/ShareProducts/ShareProductsView';

import SelectDeliveryWayView from 'bundle-loader?lazy&name=SelectDeliveryWayView!pages/Shop/CheckOrder/SelectDeliveryWay/SelectDeliveryWayView';
import ChangePickUpInfoView from 'bundle-loader?lazy&name=ChangePickUpInfoView!pages/Shop/CheckOrder/ChangePickUpInfo/ChangePickUpInfoView';
import PayMentView from 'bundle-loader?lazy&name=PayMentView!pages/Shop/PayMent/PayMentView';
import PayQRCodeView from 'bundle-loader?lazy&name=PayMentView!pages/Shop/PayMent/PayQRCode/PayQRCodeView';
import PayAliQRCodeView from 'bundle-loader?lazy&name=PayMentView!pages/Shop/PayMent/PayAliQRCode/PayAliQRCodeView';

import PayMentTransfer from 'bundle-loader?lazy&name=PayMentTransfer!pages/Shop/PayMent/Transfer/TransferView';
import PayFormView from 'bundle-loader?lazy&name=PayFormView!pages/Shop/PayMent/PayForm/indexView';
import PayFormFuiouView from 'bundle-loader?lazy&name=PayFormFuiouView!pages/Shop/PayMent/PayForm/indexFuiouView';

import PaySuccessView from 'bundle-loader?lazy&name=PaySuccessView!pages/Shop/PayMent/PaySuccess/PaySuccessView';
import PaySuccessLiteView from 'bundle-loader?lazy&name=PaySuccessLiteView!pages/Shop/PayMent/PaySuccess/PaySuccessLiteView';
import PayTipView from 'bundle-loader?lazy&name=PayTipView!pages/Shop/PayMent/PayTip/PayTipView';
import PayByQrCodeView from 'bundle-loader?lazy&name=PayByQrCodeView!pages/Shop/PayMent/PayByQRcode/index';
import AddBackCardView from 'bundle-loader?lazy&name=AddBackCardView!pages/Shop/AddBackCard/index';
import AddBackCardView2 from 'bundle-loader?lazy&name=AddBackCardView2!pages/Shop/AddBackCard2/index';
import AddBackCardView3 from 'bundle-loader?lazy&name=AddBackCardView2!pages/Shop/AddBackCard3/index';
import BankCamera from 'bundle-loader?lazy&name=BankCamera!pages/Shop/BankCamera/index';
import AlipaySchemeView from 'bundle-loader?lazy&name=AlipayScheme!pages/Shop/PayMent/AlipayScheme/AlipaySchemeView';

// 微信登录认证中转页
import WechaPaytAuthView from 'bundle-loader?lazy&name=WechatPayAuthView!pages/Shop/WechatAuth/WechatPayAuthView.js';
import WechatBackLoginAuthView from 'bundle-loader?lazy&name=WechatBackLoginAuthView!pages/Shop/WechatAuth/WechatBackLoginAuthView.js';
import WechatBaseLoginAuthView from 'bundle-loader?lazy&name=WechatBaseLoginAuthView!pages/Shop/WechatAuth/WechatBaseLoginAuthView.js';
import SelectBindCardCodeView from 'bundle-loader?lazy&name=SelectBindCardCodeView!pages/Shop/WechatAuth/SelectBindCardCode/SelectBindCardCodeView.js';
import WorkAuthView from 'bundle-loader?lazy&name=WorkAuthView!pages/Shop/WechatAuth/WorkAuth/WorkAuthView.js';
import WorkPrivateAuthView from 'bundle-loader?lazy&name=WorkPrivateAuthView!pages/Shop/WechatAuth/WorkPrivateAuth/WorkPrivateAuthView.js';

// 访客
import KeyCustomersView from 'bundle-loader?lazy&name=KeyCustomersView!pages/Shop/Visitor/KeyCustomers/KeyCustomersView';
import CustomerInfoView from 'bundle-loader?lazy&name=CustomerInfoView!pages/Shop/Visitor/CustomerInfo/CustomerInfoView';
import MyShareView from 'bundle-loader?lazy&name=MyShareView!pages/Shop/Visitor/MyShare/MyShareView';
import ActivitiesOrder from 'bundle-loader?lazy&name=MyShareView!pages/Shop/Visitor/MyShare/activitiesOrder/activitiesOrderView'; // 群主活动列表页

// 逛素材
import GuangView from 'bundle-loader?lazy&name=GuangView!pages/Shop/Guang/GuangView';
import GuangVideoGalleryView from 'bundle-loader?lazy&name=GuangView!pages/Shop/Guang/VideoGallery/VideoGalleryView';

// 抽奖
import DrawView from 'bundle-loader?lazy&name=DrawView!pages/Shop/Draw/DrawView';

import ShareReconstituTransitView from 'bundle-loader?lazy&name=ShareReconstituTransitView!pages/Shop/Draw/ShareReconstituTransit/index';

// 会员模块
// 首页模块

// 资格购跳转中间页
import ControlCenterView from 'bundle-loader?lazy&name=ControlCenterView!pages/Shop/Product/ControlCenter/ControlCenterView';

import PlaygroundView from 'bundle-loader?lazy&name=playgroundView!pages/Shop/Playground/index';

// 在线开放
import FormulaView from 'bundle-loader?lazy&name=formulaView!pages/Shop/Formula/FormulaView';
import ExpertsView from 'bundle-loader?lazy&name=expertsView!pages/Shop/Formula/Experts/ExpertsView';

import FreeShippingView from 'bundle-loader?lazy&name=expertsView!pages/Shop/Product/FreeShipping/index';

import HomeRouterConfig from './Home/RouterConfig';
import MemberRouterConfig from './Member/RouterConfig';

// 宫主会
import PriaHome from 'bundle-loader?lazy&name=priaView!biz-micro-services-ui/project/pria/pages/home/index';
import PriaShoppingCart from 'bundle-loader?lazy&name=priaView!biz-micro-services-ui/project/pria/pages/shoppingCart/index';
import PriaIncome from 'bundle-loader?lazy&name=priaView!biz-micro-services-ui/project/pria/pages/income/index';

const RouterConfig = [
  ...HomeRouterConfig,
  ...MemberRouterConfig,
  {
    path: '/shop/visitor/keyCustomers',
    title: '重点意向客户',
    component: () => {
      return createBundle(KeyCustomersView);
    }
  },
  {
    path: '/shop/guang',
    title: '逛素材',
    component: () => {
      return createBundle(GuangView);
    }
  },
  {
    path: '/shop/guang/videoGallery',
    title: 'videoGallery',
    component: () => {
      return createBundle(GuangVideoGalleryView);
    }
  },
  {
    path: '/shop/visitor/customerInfo',
    title: '客户信息',
    component: () => {
      return createBundle(CustomerInfoView);
    }
  },
  {
    path: '/shop/visitor/myShare',
    title: '我的分享',
    component: () => {
      return createBundle(MyShareView);
    }
  },
  {
    path: '/shop/visitor/activitiesOrder',
    title: '订单列表',
    component: () => {
      return createBundle(ActivitiesOrder);
    }
  },
  {
    path: '/shop/productCategories',
    title: '产品目录',
    component: () => {
      return createBundle(ProductCategoriesView);
    }
  },
  {
    path: '/shop/search',
    title: '产品搜索',
    component: () => {
      return createBundle(ProductSearchView);
    }
  },
  {
    path: '/shop/productClassifySearch',
    title: '产品分类搜索',
    component: () => {
      return createBundle(ProductClassifySearchView);
    }
  },
  {
    path: '/shop/productClassifySearchResult',
    title: '产品分类搜索结果',
    component: () => {
      return createBundle(ProductClassifySearchResultView);
    }
  },
  {
    path: '/shop/productList',
    title: '产品列表',
    component: () => {
      return createBundle(ProductListView);
    }
  },
  {
    path: '/shop/qualification',
    title: '资格购',
    component: () => {
      return createBundle(QualificationView);
    }
  },
  {
    path: '/shop/qualificationPage',
    title: '资格购活动',
    component: () => {
      return createBundle(QualificationPageView);
    }
  },
  {
    path: '/shop/qualificationActivityListView',
    title: '活动列表',
    component: () => {
      return createBundle(QualificationActivityListView);
    }
  },
  {
    // 产品详情
    path: '/shop/productDetail/:productId',
    title: '产品详情',
    component: () => {
      return createBundle(ProductDetailView);
    }
  },
  {
    // 产品详情
    path: '/shop/specialProductDetail/:productId',
    title: '产品详情',
    component: () => {
      return createBundle(SpecialProductDetailView);
    }
  },
  {
    // 问答详情
    path: '/shop/QuestionDetail',
    title: '产品问答',
    component: () => {
      return createBundle(QuestionDetailView);
    }
  },
  {
    path: '/shop/ProductEvaluate',
    title: '查看评论',
    component: () => {
      return createBundle(ProductEvaluate);
    }
  },
  {
    path: '/shop/ProductEvaluate/detail',
    title: '评论详情',
    component: () => {
      return createBundle(ProductEvaluateDetailView);
    }
  },
  {
    path: '/shop/shoppingCart',
    title: '购物车',
    component: () => {
      return createBundle(ShoppingCartView);
    }
  },
  {
    path: '/shop/shareProducts',
    title: '购物车',
    component: () => {
      return createBundle(ShareProductsView);
    }
  },
  {
    path: '/shop/activityProductList',
    title: '活动产品列表',
    component: () => {
      return createBundle(ActivityProductListView);
    }
  },
  {
    path: '/shop/checkOrder',
    title: '提交订单',
    component: () => {
      return createBundle(CheckOrderView);
    }
  },
  {
    path: '/shop/giftCheckOrder',
    title: '提交订单',
    component: () => {
      return createBundle(GiftCheckOrderView);
    }
  },
  {
    path: '/shop/giftCheckOrder/GiftNewAddressView',
    title: '收货地址',
    component: () => {
      return createBundle(GiftNewAddressView);
    }
  },
  {
    path: '/shop/giftCheckOrder/Detail/:tradeNo',
    title: '分享订单详情',
    component: () => {
      return createBundle(GiftOrderDetailView);
    }
  },
  {
    path: '/shop/checkOrder/selectDeliveryWay',
    title: '选择收货方式',
    component: () => {
      return createBundle(SelectDeliveryWayView);
    }
  },
  {
    path: '/shop/checkOrder/changePickUpInfo',
    title: '修改自提信息',
    component: () => {
      return createBundle(ChangePickUpInfoView);
    }
  },
  {
    path: '/shop/payMent/:tradeNo',
    title: '支付',
    component: () => {
      return createBundle(PayMentView);
    }
  },
  {
    path: '/shop/BankCamera',
    title: '银行卡摄像头',
    component: () => {
      return createBundle(BankCamera);
    }
  },
  {
    path: '/shop/addBackCard',
    title: '添加银行卡',
    component: () => {
      return createBundle(AddBackCardView);
    }
  },
  {
    path: '/shop/addBackCard2',
    title: '添加银行卡2',
    component: () => {
      return createBundle(AddBackCardView2);
    }
  },
  {
    path: '/shop/addBackCard3',
    title: '添加银行卡3',
    component: () => {
      return createBundle(AddBackCardView3);
    }
  },
  {
    path: '/shop/payByQrCode',
    title: '支付',
    component: () => {
      return createBundle(PayByQrCodeView);
    }
  },
  {
    path: '/shop/payQRCode',
    title: '支付',
    component: () => {
      return createBundle(PayQRCodeView);
    }
  },
  {
    path: '/shop/payAliQRCode',
    title: '支付',
    component: () => {
      return createBundle(PayAliQRCodeView);
    }
  },
  {
    path: '/shop/payMentTransfer',
    title: '支付',
    component: () => {
      return createBundle(PayMentTransfer);
    }
  },
  {
    path: '/shop/payForm',
    title: '发送验证码',
    component: () => {
      return createBundle(PayFormView);
    }
  },
  {
    path: '/shop/payForm/fuiou',
    title: '富友中间页',
    component: () => {
      return createBundle(PayFormFuiouView);
    }
  },
  {
    path: '/shop/paySuccess',
    title: '支付完成',
    component: () => {
      return createBundle(PaySuccessView);
    }
  },
  {
    path: '/shop/paySuccessLite',
    title: '支付完成',
    component: () => {
      return createBundle(PaySuccessLiteView);
    }
  },
  {
    path: '/shop/payTip/:tradeNo/:token/:userId/:amount',
    title: '支付提示',
    component: () => {
      return createBundle(PayTipView);
    }
  },
  {
    path: '/wechatPayAuth',
    title: '',
    component: () => {
      return createBundle(WechaPaytAuthView);
    }
  },
  {
    path: '/WechatBackLoginAuth',
    title: '',
    component: () => {
      return createBundle(WechatBackLoginAuthView);
    }
  },
  {
    path: '/WorkAuth',
    title: '',
    component: () => {
      return createBundle(WorkAuthView);
    }
  },
  {
    path: '/WorkPrivateAuth',
    title: '',
    component: () => {
      return createBundle(WorkPrivateAuthView);
    }
  },
  {
    path: '/WechatBaseLoginAuth',
    title: '',
    component: () => {
      return createBundle(WechatBaseLoginAuthView);
    }
  },
  {
    path: '/selectBindCardCode',
    title: '',
    component: () => {
      return createBundle(SelectBindCardCodeView);
    }
  },
  {
    path: '/shop/draw',
    title: '抽奖',
    component: () => {
      return createBundle(DrawView);
    }
  },
  {
    path: '/share/reconstitu/transit',
    title: '复消打卡分享中转页',
    component: () => {
      return createBundle(ShareReconstituTransitView);
    }
  },
  {
    path: '/shop/controlCenter/:keyValue',
    title: '',
    component: () => {
      return createBundle(ControlCenterView);
    }
  },
  {
    path: '/shop/playground',
    title: '',
    component: () => {
      return createBundle(PlaygroundView);
    }
  },
  {
    path: '/shop/formula',
    title: '',
    component: () => {
      return createBundle(FormulaView);
    }
  },
  {
    path: '/shop/formula/experts',
    title: '',
    component: () => {
      return createBundle(ExpertsView);
    }
  },
  {
    path: '/shop/alipayScheme',
    title: '',
    component: () => {
      return createBundle(AlipaySchemeView);
    }
  },
  {
    path: '/freeShipping',
    title: '',
    component: () => {
      return createBundle(FreeShippingView);
    }
  },
  {
    path: '/priaHome',
    title: '宫主会商城',
    component: () => {
      return createBundle(PriaHome);
    }
  },
  {
    path: '/priaShoppingCart',
    title: '宫主会购物车',
    component: () => {
      return createBundle(PriaShoppingCart);
    }
  },
  {
    path: '/priaInconme',
    title: '收支明细',
    component: () => {
      return createBundle(PriaIncome);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Shop/RouterConfig.js